import { PROFILE } from './baseUrls';

export const USER_PROFILE = `${PROFILE}/profile`;
